import { defaultTheme } from '@3plearning/react-components';

class ThemeHelper {
  static getTheme(props) {
    if (props.theme && Object.keys(props.theme).length > 0) {
      return props.theme;
    }
    return defaultTheme;
  }

  static getDefaultTheme() {
    return defaultTheme;
  }
}

export default ThemeHelper;



// WEBPACK FOOTER //
// ./themes/theme-helper.js